export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10574.0a8524e6.jpg";